export default "__VITE_ASSET__CtxcMX0L__"